// ProjectEditModal.jsx
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form, Input, InputNumber, DatePicker, Select, Switch, Button, Space, message, Tabs } from 'antd';
import ImgUploader from '../../components/ImgUploader';
import { formatDate2, formatDateTime2, dayjsDate, getyhzh } from '../../utils/functions';
import CustModal from '../../components/ShowModal';
import DateInput from '../../components/DateInput';

const { Option } = Select;
const feeTypes = [
  { key: '1', label: '备案费' },
  { key: '2', label: '招标文件购买费' },
  { key: '3', label: '标书制作费' },
  { key: '4', label: '投标保证金' },
  { key: '5', label: '履约保证金/保函' },
  { key: '6', label: '其它费用' }
];
// 新建/修改项目弹窗组件（可复用）
const TbEditor = (props) => {
  const {
    visible,
    currentItem,
    onClose,
    onSaveSuccess,
    webPost,
  } = props;
  const [form] = Form.useForm();
  const formRef = useRef();
  const [yhzh, setYhzh] = useState([]);
  useEffect(() => {
    const yf = async () => {
      const zhs = await getyhzh(webPost);
      setYhzh(zhs);
    }
    yf();
    return undefined;
  }, [webPost])
  const getInitialValues = useCallback(() => {
    if (!currentItem) return { zh: '微信', iszb: true };

    const init = { ...currentItem };

    init.iszb = init.iszb === 1;
    // setImgfiles(init.files);
    console.log('init', init);
    return init;
  }, [currentItem])

  // 表单保存逻辑
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      // 处理日期
      const payload = { ...values };

      if (Array.isArray(payload.files)) {
        payload.files = payload.files.join(',');
      }

      // ID 处理
      payload.id = payload.id || 0;
      payload.iszb = payload.iszb ? 1 : 0;
      const res = await webPost('ztbsave', payload);
      if (res) {
        message.success(payload.xmmc ? '修改成功' : '新增成功');
        onClose && onClose();
        onSaveSuccess && onSaveSuccess();
      }
    } catch (err) {
      console.error(err);
      message.error('保存失败');
    }
  };

  const handleModalClose = () => {
    formRef.current?.resetFields();
    onClose && onClose();
  };

  return (
    <CustModal
      title={currentItem ? '编辑项目' : '新建项目'}
      open={visible}
      onOk={handleSave}
      onCancel={handleModalClose}
      width="70vw"
      styles={{
        body: { maxHeight: '70vh', overflowY: 'auto', paddingRight: '10px' }
      }}
    >
      <Form
        form={form}
        key={currentItem?.id || 'new'}
        ref={formRef}
        layout="vertical"
        initialValues={getInitialValues()}
        preserve={false}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
          <h4 className='responsive-grid-header'>项目信息</h4>
          <div className='responsive-grid'>
            <Form.Item label="项目编号" name="sn">
              <Input readOnly />
            </Form.Item>
            <Form.Item label="项目名称" name="xmmc">
              <Input readOnly />
            </Form.Item>
            <Form.Item label="报名日期" name="startTime" rules={[{ required: true, message: '请选择报名日期' }]}>
              <DateInput style={{width:'100%'}} />
            </Form.Item>
        
            <Form.Item label="履约保证金" name="tbbzj">
              <InputNumber />
            </Form.Item>
          </div>
        </div>
        <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
          <h4 className='responsive-grid-header'>招标开标信息</h4>
          <div className='responsive-grid'>
            <Form.Item label="截止时间" name="endtime">
              <DateInput showTime={true} style={{width:'100%'}} />
            </Form.Item>
            <Form.Item label="招标单位" name="xmdjxx1">
              <Input />
            </Form.Item>
            <Form.Item label="标书编制人" name="bsbzr">
              <Input />
            </Form.Item>
            <Form.Item label="标书审核" name="shnm1">
              <Input />
            </Form.Item>
            <Form.Item label="标书复核" name="shnm2">
              <Input />
            </Form.Item>
            <Form.Item label="签章审核" name="shnm3">
              <Input />
            </Form.Item>
            <Form.Item label="平台/登入网址" name="pt">
              <Input />
            </Form.Item>
            <Form.Item label="开标备注" name="sh1ps">
              <Input.TextArea rows={2} />
            </Form.Item>
          </div>
        </div>


        <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
          <h4 className='responsive-grid-header'>其它</h4>
          <div className='responsive-grid'>
            <Form.Item label="是否有效" name="iszb" valuePropName="checked">
              <Switch checkedChildren="有效" unCheckedChildren="无效" />
            </Form.Item>
            <Form.Item label="授权委托人" name="wtname">
              <Input />
            </Form.Item>
            <Form.Item label="项目经理" name="xmjl">
              <Input />
            </Form.Item>
            <Form.Item label="备注" name="ps">
              <Input.TextArea rows={2} />
            </Form.Item>
          </div>
        </div>
        <div style={{ marginBottom: 20, paddingBottom: 10, borderBottom: '1px solid #e8e8e8' }}>
          <h4 className='responsive-grid-header'>文件类</h4>
          <div className='responsive-grid'>
            <Form.Item label="招标文件" name="files">
              <ImgUploader />
            </Form.Item>
            <Form.Item label="其它资料" name="files1">
              <ImgUploader />
            </Form.Item>
          </div>
        </div>

      </Form>
    </CustModal>
  );
};

export default TbEditor;